import React from 'react';
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import logo from '../assets/validlabels_1.0.png';
import SectionCard from '../components/SectionCard';

interface WelcomeProps {
  onLogin: () => void;
}

const Welcome: React.FC<WelcomeProps> = ({ onLogin }) => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '78vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SectionCard sx={{ width: '100%' }}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Box component="img" src={logo} alt="Valid Labels" sx={{ height: 64, width: 'auto' }} />
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                {t('welcome.title', 'Sign in to Valid Labels')}
              </Typography>
              <Typography color="text.secondary">
                {t('welcome.subtitle', 'Open your workspace to manage labels, translations, and printing.')}
              </Typography>
            </Box>
            <Button variant="contained" onClick={onLogin} startIcon={<LoginIcon />} sx={{ minWidth: 180 }}>
              {t('welcome.cta', 'Sign In')}
            </Button>
            <Typography variant="body2" color="text.secondary">
              {t('welcome.info', 'You will be redirected to the secure sign-in page.')}
            </Typography>
          </Stack>
        </SectionCard>
      </Box>
    </Container>
  );
};

export default Welcome;

